module.exports = __webpack_public_path__ + "7b95fc47aaa5f0ddbc671273cb75822b.MP3";